"use strict";
// API endpoint path constants — used by both web and mobile clients.
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ENDPOINTS = void 0;
exports.API_ENDPOINTS = {
    // Auth
    auth: {
        me: "/api/v1/auth/me/",
        profile: "/api/v1/auth/profile/",
    },
    // Bank accounts
    accounts: {
        list: "/api/v1/accounts/",
        detail: (id) => `/api/v1/accounts/${id}/`,
        sync: (id) => `/api/v1/accounts/${id}/sync/`,
        plaidLinkToken: "/api/v1/accounts/plaid/link-token/",
        plaidExchange: "/api/v1/accounts/plaid/exchange/",
    },
    // Transactions
    transactions: {
        list: "/api/v1/transactions/",
        detail: (id) => `/api/v1/transactions/${id}/`,
        categorize: (id) => `/api/v1/transactions/${id}/categorize/`,
    },
    // Categories
    categories: {
        list: "/api/v1/categories/",
        detail: (id) => `/api/v1/categories/${id}/`,
        rules: "/api/v1/categories/rules/",
        ruleDetail: (id) => `/api/v1/categories/rules/${id}/`,
    },
    // Budgets
    budgets: {
        list: "/api/v1/budgets/",
        detail: (id) => `/api/v1/budgets/${id}/`,
        progress: (id) => `/api/v1/budgets/${id}/progress/`,
    },
    // Forecasts
    forecasts: {
        current: "/api/v1/forecasts/current/",
        generate: "/api/v1/forecasts/generate/",
        alerts: "/api/v1/forecasts/alerts/",
    },
    // Debts
    debts: {
        list: "/api/v1/debts/",
        detail: (id) => `/api/v1/debts/${id}/`,
        summary: "/api/v1/debts/summary/",
        plan: (id) => `/api/v1/debts/${id}/plan/`,
    },
    // Paycheck remainder
    paycheckRemainder: {
        list: "/api/v1/paycheck-remainder/",
        detail: (id) => `/api/v1/paycheck-remainder/${id}/`,
    },
};
//# sourceMappingURL=endpoints.js.map